<script setup>
import { ref, onMounted } from 'vue';
import { Download, Sparkles } from 'lucide-vue-next';
import { checkForUpdate } from '../lib/androidUpdate';
import { isAndroid, isPlayBuild, openExternalUrl } from '../utils/platform';

const update = ref(null);

onMounted(async () => {
  if (!isAndroid || isPlayBuild) return;
  const result = await checkForUpdate();
  if (result.available || result.required) update.value = result;
});

const download = () => {
  if (update.value?.apkUrl) openExternalUrl(update.value.apkUrl);
};

const later = () => {
  if (!update.value?.required) update.value = null;
};
</script>

<template>
  <div v-if="update" class="fixed inset-0 z-[120] bg-black/60 flex items-end md:items-center justify-center p-4 pb-[calc(env(safe-area-inset-bottom)+1rem)]">
    <div class="bg-white rounded-[24px] p-6 w-full max-w-sm text-center space-y-4">
      <div class="w-14 h-14 mx-auto rounded-full bg-[#ffd93e]/30 flex items-center justify-center">
        <Sparkles class="w-7 h-7 text-gray-900" />
      </div>
      <h2 class="text-xl font-extrabold text-gray-900 font-baloo">Nouvelle version disponible</h2>
      <p class="text-sm text-gray-600 leading-relaxed">
        Une nouvelle version de l'app Clo'Cook est prête.
        Télécharge-la pour profiter des dernières nouveautés.
      </p>
      <button @click="download" class="w-full bg-black text-white font-bold py-3.5 rounded-2xl flex items-center justify-center gap-2 active:scale-95 transition-transform">
        <Download class="w-5 h-5" />
        Télécharger la mise à jour
      </button>
      <button v-if="!update.required" @click="later" class="w-full text-sm text-gray-500 font-bold py-2">
        Plus tard
      </button>
    </div>
  </div>
</template>
